import type { SxStyle } from '@aibees/shared/theme';
import {
  advanceTableSelectionPopupItem,
  advanceTableSelectionPopupItemText,
} from '../../sx';

export const root: SxStyle = advanceTableSelectionPopupItem;

export const text: SxStyle = advanceTableSelectionPopupItemText;
